export default __webpack_public_path__ + "static/media/auth-form-image.c94b2234.jpg";